export default __webpack_public_path__ + "static/alex_moldovan-cff81732657a5ecf5bc2c08cef405131.jpg";